// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
/* 验证码输入框样式 */
input[data-v-7d9702a4]:focus {
  outline: none;
  border-color: #ff7a00;
  box-shadow: 0 0 0 2px rgba(255, 118, 0, 0.2);
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
